var map = {
	"./google-play-badge-ca.png": "zwi3",
	"./google-play-badge-en.png": "3MKX",
	"./google-play-badge-es.png": "r9fk",
	"./google-play-badge-pt.png": "ANZw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MmoP";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/google\-play\-badge\-.*\.png$
// module id = MmoP
// module chunks = 1